module.exports = __webpack_public_path__ + "img/sims.aef04769.svg";